export const environment = {
  production: false,
  faceOnly: true,
  url_processing: "http://identy:8082",
  url_models: "http://identy:8081",
  url_pub_key: "http://identy:8081"
};
